import { Component, OnInit, OnDestroy } from '@angular/core';
import { ResetPassword } from '../../../models/ResetPassword';
import { AccountService } from '../../../services/account.service';
import { NgForm } from '@angular/forms';
import { ConfirmationPageSuccessComponent } from '../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;
  public resetPwd: ResetPassword;
  public successMsg: string;
  public errorMsg: string;
  alive = true;
  constructor(private accountSvc: AccountService,
    private dataSvc: DataService,
    private router: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.resetPwd = new ResetPassword();
  }

  onSubmit(frmResetPwd: NgForm) {
    this.errorMsg = null;
    this.successMsg = null;
    this.spinner.show();

    this.accountSvc.resetPassword(this.resetPwd)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
                this.spinner.hide();
                this.showSuccessConfirmation = true;
                this.showFailConfirmation = false;
                this.successMsg = 'Thank you. An email has been sent to the email address provided' +
                ' with instructions on how to reset your password.';
                this.errorMsg = null;
                this.resetPwd = new ResetPassword();
                frmResetPwd.reset();
            },
      err => {
                this.spinner.hide();
                this.showSuccessConfirmation = false;
                this.showFailConfirmation = true;
                this.successMsg = null;
                this.errorMsg = err._body;
        }
    );
   // window.scrollTo(0, 0);
  }

  redirectToLogin(event) {
    this.router.navigate(['/pages/login']);
  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }
  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/reset-password/reset-password.component.ts